import {Parcel, parcelDecoder} from './Parcel'
import {
    ParcelPositionWithPosition,
    parcelPositionWithPositionDecoder
} from './ParcelPositionWithPosition'
import {array, Decoder, field, object} from 'json-bouncer'
import {ParcelDispatcher, parcelDispatcherDecoder} from './ParcelDispatcher'

export interface ParcelWithDetails {
    parcel: Parcel
    parcelDispatcher: ParcelDispatcher
    parcelPositionsWithPosition: ParcelPositionWithPosition[]
}

export function parcelWithPositionsDecoder(): Decoder<ParcelWithDetails> {
    return object({
        parcel: field('parcel', parcelDecoder()),
        parcelDispatcher: field('parcelDispatcher', parcelDispatcherDecoder()),
        parcelPositionsWithPosition:
            field(
                'parcelPositionsWithPosition',
                array(parcelPositionWithPositionDecoder()),
            ),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/ParcelWithDetails.ts